import { Lang } from "./translations";

export interface QuickReply {
  id: string;
  label: string;
  message: string;
}

export interface ChatStrings {
  title: string;
  subtitle: string;
  openLabel: string;
  greeting: string;
  placeholder: string;
  send: string;
  close: string;
  error: string;
  spanishSwitched: string;
  quickReplies: QuickReply[];
}

export const chatStrings: Record<Lang, ChatStrings> = {
  en: {
    title: "Ask R3",
    subtitle: "Questions about our services? Ask away.",
    openLabel: "Ask R3",
    greeting:
      "Hi! I'm R3, the R3Stan Drywall assistant. I can tell you about our drywall services, R3 Services, or how to request a bid. What can I help you with?",
    placeholder: "Type your question…",
    send: "Send",
    close: "Close chat",
    error:
      "Sorry, something went wrong on my end. You can reach Rogelio directly at 281-541-8800.",
    spanishSwitched: "¡Claro! Ahora podemos hablar en español. ¿En qué puedo ayudarle?",
    quickReplies: [
      {
        id: "drywall",
        label: "Drywall Services",
        message: "What drywall and construction services do you offer?",
      },
      {
        id: "r3",
        label: "R3 Services",
        message: "What does R3 Services do?",
      },
      {
        id: "bid",
        label: "Request a Bid",
        message: "How do I request a bid for my project?",
      },
      { id: "spanish", label: "Hablar Español", message: "" },
    ],
  },
  es: {
    title: "Pregunta a R3",
    subtitle: "¿Dudas sobre nuestros servicios? Pregunte aquí.",
    openLabel: "Pregunta a R3",
    greeting:
      "¡Hola! Soy R3, el asistente de R3Stan Drywall. Puedo contarle sobre nuestros servicios de tablaroca, R3 Services, o cómo solicitar una cotización. ¿En qué puedo ayudarle?",
    placeholder: "Escriba su pregunta…",
    send: "Enviar",
    close: "Cerrar chat",
    error:
      "Lo siento, algo salió mal de mi lado. Puede contactar a Rogelio directamente al 281-541-8800.",
    spanishSwitched: "¡Claro! Ahora podemos hablar en español. ¿En qué puedo ayudarle?",
    quickReplies: [
      {
        id: "drywall",
        label: "Servicios de Tablaroca",
        message: "¿Qué servicios de tablaroca y construcción ofrecen?",
      },
      {
        id: "r3",
        label: "R3 Services",
        message: "¿Qué hace R3 Services?",
      },
      {
        id: "bid",
        label: "Solicitar Cotización",
        message: "¿Cómo solicito una cotización para mi proyecto?",
      },
      { id: "spanish", label: "Hablar Español", message: "" },
    ],
  },
};
